function Home() {
  return (
    <div className="mt-16 Home">
      <section class="text-black body-font">
        <div class="container mx-auto flex px-5 py-8 items-center justify-center flex-col">
          <div class="text-center lg:w-2/3 w-full">
            <h1
              class="title-font sm:text-7xl text-4xl mb-4 font-medium  orange-text "
              style={{ fontFamily: "font1" }}
            >
              Ecoz
            </h1>
            <h1 class="title-font sm:text-4xl text-xl mb-4 font-medium text-gray-900">
              100% on-chain nft ecosystem
            </h1>
            <p class="mb-8 leading-relaxed text-left text-xs sm:text-xl">
              Ecoz are an on-chain ecosystem made up of three different species
              that compete in the Meta-Jungle for $THRIVE. The genesis
              collection consists of Jaguars, Bush Bucks, and Banana Trees.
              Balance of the ecosystem is crucial to each species' survival
              making the relationship between them very important to learn.
            </p>
            <div class="flex justify-center">
              <a
                href="/mint"
                class="orange border-white border-2 shadow-md text-white px-10 p-2 text-lg hover:scale-105 transition duration-500 ease-in-out transform hover:shadow-lg hover:text-orange"
              >
                Mint Now
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
